export default __webpack_public_path__ + "static/media/menu-collect-hover.efda109e.svg";